module.exports = __webpack_public_path__ + "img/icon_mine_digital.b8dd7b11.png";